import { jwtDecode } from 'jwt-decode';

import { AppType, OrgType, type IJwtPayload } from './types';

const getOrganizationsFromToken = (token: string) => {
  try {
    const payload = jwtDecode<IJwtPayload>(token);
    return payload?.organizations ?? [];
  } catch (error) {
    console.error('Error decoding token for orgs:', error);
    return [];
  }
};

export const validateOrgAccess = (token: string, appType: AppType): boolean => {
  const organizations = getOrganizationsFromToken(token);

  if (organizations.length === 0) return false;

  const requiredType =
    appType === AppType.ADMIN
      ? OrgType.SUPER
      : appType === AppType.CLIENT
        ? OrgType.REGULAR
        : null;

  if (!requiredType) return false;

  return organizations.some(org => org.type === requiredType);
};
